import React from "react";
import { ButtonProps } from "../Button/Button";
import { StyledPaymentButton } from "./PaymentButton.styles";

const PaymentButton: React.FC<ButtonProps> = React.memo((buttonProps) => (
  <StyledPaymentButton {...buttonProps} />
));

export default PaymentButton;
